<template>
  <v-container>
    <v-row class="text-center" id="top">
      <v-col cols="12">
        <h2 class="text-lg-h5 mb-2">
          본초 병증 처방 서적을 조합하여 원하는 처방을 찾아보세요
        </h2>
        <p>
          검색된 처방에서 중요하게 사용된 본초와 병증도 알아 낼 수 있습니다.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <SearchTagInput
          :dataDict="dataDict"
          :inputMsg="tagInputMsg1"
          :allReady="allReady"
          @tagUpdated="searchListPlus"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <SearchTagInput
          :dataDict="dataDict"
          :inputMsg="tagInputMsg2"
          :allReady="allReady"
          @tagUpdated="searchListMinus"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <div class="text-center" v-if="allReady">
          <v-btn
            class="ma-2"
            color="primary"
            rounded
            text-color="white"
            large
            @click="showResult()"
          >
            Search Formulas
            <v-chip
              right
              size="24"
              class="blue darken-4 ml-2"
              v-text="formulaRstIdxList.length"
            >
            </v-chip>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12" sm="6">
        <div class="text-center" v-if="allReady">
          <v-btn
            class="ma-2"
            color="primary"
            rounded
            text-color="white"
            large
            @click="showWordcloud()"
          >
            find significant terms
            <v-chip
              right
              size="24"
              class="blue darken-4 ml-2"
              v-text="g2Values.length"
            >
            </v-chip>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <RelationGraph
      v-if="showWordcloudAction"
      :g2Values="g2ValuesRst"
      :showWordcloudAction="showWordcloudAction"
    />

    <FormulaList
      v-if="showResultAction"
      :formulaList="formulaList"
      :dataDict="dataDict"
      :tagsInIdx="tagsInIdx"
      :formulaRstIdxList="formulaRstIdxList"
      :showResultAction="showResultAction"
    />
    <GoTopBtn v-if="showResultAction" />
  </v-container>
</template>

<script>
'use strict'

import SearchTagInput from '../components/SearchTagInput';
import FormulaList from '../components/FormulaList';
import RelationGraph from '../components/RelationGraph';
import GoTopBtn from '../components/GoTopBtn';
import { helper } from '../helper.js';
import { setUtils } from '../helper.js';
import { relationUtils } from '../helper.js';
import { EventBus } from '../eventBus';

let convertIdx2Data = (idxList, formulaRstIdxList) => {
  return idxList.map(e => formulaRstIdxList[e]);
};

export default {
  name: 'Search',
  metaInfo: {
    title: 'Search',
    titleTemplate: '%s | Every Formula',
  },
  components: {
    SearchTagInput,
    FormulaList,
    RelationGraph,
    GoTopBtn,
  },
  data() {
    return {
      tagInputMsg1: {
        label: 'Include Keywords (본초 병증 처방 서적)',
        suffix: '포함',
      },
      tagInputMsg2: {
        label: 'Exclude Keywords (본초 병증 처방 서적)',
        suffix: '배제',
      },
      formulaList: null,
      formulaIdx: [],
      dataDict: null,
      dataRidx: null,
      allReady: false,
      setEventBus: [],
      tagsInIdx: [],
      formulaInIdx: [],
      formulaOutIdx: [],
      formulaRstIdxList: [],
      showResultAction: false,
      g2Values: [],
      g2ValuesRst: [],
      minFreq: 5,
      g2cuoffValue: 3.84, // 6.63
      showWordcloudAction: false,
    };
  },
  created() {
    helper.log('Search Comp Created');
    if (EventBus.$data.dataReady) {
      this.formulaList = EventBus.$data.formulaList;
      this.formulaIdx = EventBus.$data.formulaIdx;
      this.dataRidx = EventBus.$data.dataRidx;
      this.dataDict = EventBus.$data.dataDict;
      // this.dataNet = EventBus.$data._dataNet
      this.allReady = true;
      helper.log(EventBus.$data);
    } else {
      EventBus.$on('appDataReady', d => {
        this.setEventBus.push('appDataReady');
        this.formulaList = d.formulaList;
        this.formulaIdx = d.formulaIdx;
        this.dataRidx = d.dataRidx;
        this.dataDict = d.dataDict;
        // this.dataNet = d.dataNet
        this.allReady = true;
        helper.log(d);
      });
    }
  },
  destroyed() {
    if (this.setEventBus) {
      for (let e of this.setEventBus) {
        EventBus.$off(e);
      }
    }
  },
  methods: {
    init() {
      this.showResultAction = false;
      this.showWordcloudAction = false;
    },
    searchListPlus(tagsIn) {
      // this.tagsIn = tagsIn
      this.showResultAction = false;
      helper.log('... Searching because One Tag added');
      let intersectionTagsIdx = [];
      if (tagsIn.length > 0) {
        // helper.log( tagsIn )
        let tagsInIdx = tagsIn.map(e => ({
          idx: this.dataDict.name2idx[e.g][e.n],
          group: e.g,
        }));
        this.tagsInIdx = Object.freeze(tagsInIdx);
        // helper.log( tagsInIdx )
        let tagsInRidx = tagsInIdx.map(e => this.dataRidx[e.group][e.idx]);
        // helper.log( tagsInRidx )
        intersectionTagsIdx =
          tagsIn.length == 1
            ? tagsInRidx[0]
            : tagsInRidx.reduce(setUtils.intersectionCallback);
      }
      this.formulaInIdx = Object.freeze(intersectionTagsIdx);
      // helper.log( "this.formulaInIdx" )
      // helper.log( this.formulaInIdx )
      this.searchData();
    },
    searchListMinus(tagsOut) {
      this.showResultAction = false;
      helper.log('... Searching because One Tag removed');
      let unionTagsIdx = [];
      if (tagsOut.length > 0) {
        let tagsOutIdx = tagsOut.map(e => ({
          idx: this.dataDict.name2idx[e.g][e.n],
          group: e.g,
        }));
        let tagsOutRidx = tagsOutIdx.map(e => this.dataRidx[e.group][e.idx]);
        unionTagsIdx =
          tagsOut.length === 1
            ? tagsOutRidx[0]
            : tagsOutRidx.reduce(setUtils.unionCallback);
        unionTagsIdx = setUtils.uniq_arr(unionTagsIdx); // Uniq
      }
      this.formulaOutIdx = Object.freeze(unionTagsIdx);
      helper.log('this.formulaOutIdx');
      helper.log(this.formulaOutIdx);
      this.searchData();
    },
    searchData() {
      this.init();
      if (this.formulaOutIdx.length == 0) {
        this.formulaRstIdxList = this.formulaInIdx;
      } else {
        helper.log(this.formulaInIdx.length);
        helper.log(this.formulaIdx);
        this.formulaRstIdxList =
          this.formulaInIdx.length == 0
            ? this.formulaIdx.filter(e => {
                return !this.formulaOutIdx.includes(e);
              })
            : this.formulaInIdx.filter(e => {
                return !this.formulaOutIdx.includes(e);
              });
      }
      helper.log('this.formulaRstIdxList');
      helper.log(this.formulaRstIdxList);

      this.g2Values = Object.freeze(
        relationUtils.get_g2Values(
          this.tagsInIdx,
          this.formulaRstIdxList,
          this.formulaList,
          this.dataDict,
          this.minFreq,
          this.g2cuoffValue
        )
      );
      helper.log('this.g2Values');
      helper.log(this.g2Values);
    },
    showResult() {
      if (this.formulaRstIdxList.length > 200) {
        if (
          confirm(
            '검색결가 많아 출력에 시간이 오래 걸릴 수 있습니다. 계속 하시겠습니까?'
          )
        ) {
          this.showResultAction = true;
          this.showWordcloudAction = false;
        } else {
          return;
        }
      } else {
        this.showResultAction = true;
        this.showWordcloudAction = false;
      }
    },
    showWordcloud() {
      this.showResultAction = false;
      this.showWordcloudAction = true;
      // this.g2ValuesRst = this.g2Values;
      this.g2ValuesRst = helper.deepClone(this.g2Values);
    },
  }, // method
  computed: {}, // computed
};

// REF:
// https://cli.vuejs.org/guide/mode-and-env.html#example-staging-mode
</script>
